module.exports = new __parcel__URL__("homebase_tiles-export64_v2.9af65787.png").toString();